export enum ProductEventsEnum {
  AddToCartBtnClick = 'AddToCartBtnClick',
}
